import { render, staticRenderFns } from "./LoaderOverlay.vue?vue&type=template&id=4c0daa52&scoped=true"
import script from "./LoaderOverlay.vue?vue&type=script&lang=js"
export * from "./LoaderOverlay.vue?vue&type=script&lang=js"
import style0 from "./LoaderOverlay.vue?vue&type=style&index=0&id=4c0daa52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0daa52",
  null
  
)

export default component.exports